











import Vue from 'vue'
import store from '@/store'
import bus from '@/services/bus'
import activeInfoPage from '@/components/Ui/ActiveInfoPage/ActiveInfoPage.vue'
import wikiPageModel from '@/models/wiki/wikiPage'
import WikiPageConfig from '@/activePages/wiki/page'
import config from '@/config'
import {CONF_WEBUI_LINK} from '@/constants'

export default Vue.extend({
  props: {
    id: String
  },
  components: {
    activeInfoPage
  },
  data () {
    return {
      config: WikiPageConfig,
      webuiLink: config(CONF_WEBUI_LINK)
    }
  },
  methods: {
    async copyLink () {
      try {
        // @ts-ignore
        await this.$copyText(`${this.webuiLink}#/wiki/${this.id}`)
        // @ts-ignore
        this.$message.success(this.$t('labels.copyied_to_clipboard'))
      } catch (error) {
        console.error('LOG: copyLink -> error', error)
      }
    }
  },
  computed: {
    activeTab: {
      get (): string {
        return this.$route.name!
      },
      set () {

      }
    },
    wikiPage (): wikiPageModel {
      return this.$store.state.wiki.pages[this.id]
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('wiki/getPage', to.params.id)
      // @ts-ignore
      bus.$emit('pathChanged')
      next()
    } catch (error) {
      next('notFound')
    }
  }
})
